export function valueCount() {
  this.fCount = 1;
}
